var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPressure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_31703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4291 14.9114C16.0092 14.4914 15.3306 14.4914 14.9107 14.9114C11.5506 18.2606 11.5506 23.7314 14.9107 27.0914C15.3136 27.4944 16.0009 27.5197 16.4291 27.0914C16.8492 26.6714 16.8492 25.9929 16.4291 25.5729C13.909 23.0529 13.909 18.9498 16.4291 16.4298C16.8492 16.0098 16.8492 15.3314 16.4291 14.9114Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1382 30.1391C35.1781 25.099 35.1781 16.9036 30.1382 11.8637C29.7183 11.4436 29.0397 11.4436 28.6198 11.8637C28.1997 12.2837 28.1997 12.9621 28.6198 13.3822C32.8197 17.5821 32.8197 24.4206 28.6198 28.6098C28.1997 29.0298 28.1997 29.7191 28.6198 30.1391C29.0483 30.5678 29.7356 30.5418 30.1382 30.1391Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5708 27.0914C25.9744 27.4951 26.6615 27.5189 27.0894 27.0914C30.4493 23.7314 30.4493 18.2714 27.0894 14.9114C26.6693 14.4914 25.9909 14.4914 25.5708 14.9114C25.1509 15.3314 25.1509 16.0098 25.5708 16.4298C28.0909 18.9498 28.0909 23.0529 25.5708 25.5729C25.1509 25.9929 25.1509 26.6714 25.5708 27.0914Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.862 30.1391C12.317 30.5715 12.9804 30.5391 13.3803 30.1391C13.8005 29.7191 13.8005 29.0298 13.3803 28.6098C9.18045 24.4206 9.18045 17.5821 13.3803 13.3822C13.8005 12.9621 13.8005 12.2837 13.3803 11.8637C12.9605 11.4436 12.2821 11.4436 11.862 11.8637C6.82205 16.9036 6.82205 25.099 11.862 30.1391Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0055 17.4493C19.046 17.4493 17.459 19.0454 17.459 20.9959C17.459 22.9555 19.046 24.5426 21.0055 24.5426C22.9561 24.5426 24.5521 22.9555 24.5521 20.9959C24.5521 19.0454 22.9561 17.4493 21.0055 17.4493Z",
    fill: "#00994E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_31703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressure);
export default __webpack_public_path__ + "static/media/pressure.4a12eef3f7e2f031bbe2041888af1757.svg";
export { ForwardRef as ReactComponent };